'use strict';
jQuery($ => {
	// Gecko Box script
	// Wrap defined content
	$('.open-modestbox').each(function() {
		var open = $(this).data('open');
		$('#'+open).wrapAll('<div class="modestbox"><div class="modestbox__wrapper"></div></div>');
		$('#'+open).parent('.modestbox__wrapper').before('<div class="modestbox__overlay close-modestbox"></div>')
	});
	//Open Action
	$('body').on('click', '.open-modestbox', function(e){
		e.preventDefault();
		var open = $(this).data('open');
		$('#'+open).parents('.modestbox').addClass('modestbox--show');
	});
	//Close Action
	$('body').on('click', '.close-modestbox', function(e){
		e.preventDefault();
		$('.modestbox').removeClass('modestbox--show');
	});
	
});